import React, { useState } from 'react';

interface RouteLegendProps {
  showActualRoute: boolean;
  showOptimalRoute: boolean;
  showTollFees: boolean;
  onToggleActualRoute: () => void;
  onToggleOptimalRoute: () => void;
  onToggleTollFees: () => void;
}

const RouteLegend: React.FC<RouteLegendProps> = ({
  showActualRoute,
  showOptimalRoute,
  showTollFees,
  onToggleActualRoute,
  onToggleOptimalRoute,
  onToggleTollFees
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="card-footer bg-light">
      <div className="d-flex justify-content-between align-items-center">
        <strong className="text-secondary">
          <i className="bi bi-map me-2"></i>
          Map Legend
        </strong>
        <button
          className="btn btn-sm btn-link text-secondary p-0"
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? 'Collapse' : 'Expand'}
        >
          <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'}`}></i>
        </button>
      </div>

      {isExpanded && (
        <div className="mt-2">
          {/* Route Toggles */}
          <div className="d-flex flex-wrap gap-3 mb-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggleActualRoute"
                checked={showActualRoute}
                onChange={onToggleActualRoute}
              />
              <label className="form-check-label d-flex align-items-center" htmlFor="toggleActualRoute">
                <div
                  style={{
                    width: '24px',
                    height: '3px',
                    backgroundColor: '#dc3545',
                    marginRight: '6px'
                  }}
                ></div>
                <small>Actual Route</small>
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggleOptimalRoute"
                checked={showOptimalRoute}
                onChange={onToggleOptimalRoute}
              />
              <label className="form-check-label d-flex align-items-center" htmlFor="toggleOptimalRoute">
                <div
                  style={{
                    width: '24px',
                    height: '3px',
                    backgroundColor: '#28a745',
                    marginRight: '6px',
                    backgroundImage: 'linear-gradient(90deg, #28a745 50%, transparent 50%)',
                    backgroundSize: '8px 100%'
                  }}
                ></div>
                <small>Optimal Route</small>
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggleTollFees"
                checked={showTollFees}
                onChange={onToggleTollFees}
              />
              <label className="form-check-label" htmlFor="toggleTollFees">
                <small>Toll Fees</small>
              </label>
            </div>
          </div>

          
        </div>
      )}
    </div>
  );
};

export default RouteLegend;
